export default {
    "validation": {
        "min": "The value must be at least {min}",
        "max": "The value can be no more than {max}",
        "required": "This field is required",
        "requiredTrue": "This field must be set",
        "email": "A valid email address is required",
        "minLength": "The value must have at least {requiredLength, plural, one {# character} other {# characters}}",
        "maxLength": "The value can have no more than {requiredLength, plural, one {# character} other {# characters}}",
        "pattern": "The value is invalid",
        "unique": "This field must be unique",
        "integer": "The value must be an integer",
        "number": "The value must be a number",
        "date": "",
        "range": "The first value must be less than or equal to the second"
    }
};
